module.exports = __webpack_public_path__ + "static/media/HelveticaNeueCyr-Thin.afe760ff.ttf";